import { get } from "lodash";
import {
  ColumnDefinitionService,
  vsName as ColumnDefinitionServiceName,
} from "../../../../records/grids/columns/columnDefinitionService";
import {
  GridSettingsService,
  vsName as GridSettingsServiceName,
} from "../../../../records/grids/settings/gridSettingsService";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../../../records/server/serverUtility";
import { GridConfiguration } from "../../../../records/views/recordGridView";
import { FilterProvider } from "../../../../records/grids/columns/filters/FilterProvider";
import { OptionsFilter } from "../../../../records/grids/columns/filters/subFilters/OptionsFilter";
import { moneyValueGetterFactory } from "../../../../records/grids/cells/valueGetters";
import { ICompileService } from "angular";
import { RecordDataSource } from "../../../../records/grids";

ContractGridConfigurationFactory.$inject = [
  ColumnDefinitionServiceName,
  ServerUtilityName,
  GridSettingsServiceName,
  "$compile",
];
export function ContractGridConfigurationFactory(
  columnDefinitionService: ColumnDefinitionService,
  serverUtility: ServerUtility,
  gridSettingsService: GridSettingsService,
  $compile: ICompileService
): GridConfiguration {
  return {
    gridDataSource: new RecordDataSource(
      serverUtility,
      "/api/contract/contract"
    ),
    defaultSort: "ContractNumber",
    nameSingular: "Contract",
    showAddButton: true,
    showAddButtonPermission: ["contractEdit", "contractViewSensitive"],
    gridSettings: gridSettingsService.getGridSettings(
      Symbol("contract.type.contract")
    ),
    columns: [
      columnDefinitionService.getStringColDef({
        field: "ContractMachineManufacturerName",
        header: "Contract Manufacturer",
      }),
      columnDefinitionService.getStringColDef({
        field: "ContractNumber",
      }),
      columnDefinitionService.getStringColDef({
        field: "Cbr",
        header: "Cbr#",
      }),
      columnDefinitionService.getStringColDef({
        field: "Requisition",
        header: "Requisition#",
        hide: true,
      }),
      columnDefinitionService.getStringColDef({
        field: "PO",
        header: "PO#",
        hide: true,
      }),
      columnDefinitionService.getDateColDef({
        field: "ContractStartDate",
        header: "Contract Start",
      }),
      columnDefinitionService.getDateColDef({
        field: "ContractEndDate",
        header: "Contract End",
      }),
      columnDefinitionService.getStringColDef({
        field: "TypeOfAgreementName",
        header: "Type Of Agreement ",
      }),
      columnDefinitionService.getNumberColDef({
        field: "ContractValue",
        header: "Contract Value",
        valueGetter: moneyValueGetterFactory(),
        hide: true,
        requiresPermission: "contractViewSensitive",
      }),
      columnDefinitionService.getStringColDef({
        field: "OwnedLeased",
        header: "Owned/Leased",
        hide: true,
        filter: new FilterProvider("OwnedLeased", $compile)
          .addFilter(
            "=",
            new OptionsFilter({
              displayName: "=",
              options: [
                {
                  display: "Leased",
                  value: "Leased",
                },
                {
                  display: "Owned",
                  value: "Owned",
                },
              ],
              queryFieldNames: ["OwnedLeased"],
            })
          )
          .getGridFilterFactory(),
        requiresPermission: "contractViewSensitive",
      }),
      columnDefinitionService.getStringColDef({
        field: "PerformanceGuaranteeTypeName",
        header: "Performance Guarantee",
        hide: true,
        requiresPermission: "contractViewSensitive",
      }),
      columnDefinitionService.getStringColDef({
        field: "Details",
        header: "Details",
        requiresPermission: "contractViewSensitive",
        hide: true,
      }),
      columnDefinitionService.getStringColDef({
        field: "FeeStructureTypeName",
        header: "Fee Structure",
        requiresPermission: "contractViewSensitive",
        hide: true,
      }),
      columnDefinitionService.getStringColDef({
        field: "Notes",
        header: "Notes",
        hide: true,
      }),
      columnDefinitionService.getStringColDef({
        field: "ExecutedContract",
        header: "Executed Contract",
        hide: true,
        requiresPermission: "contractViewSensitive",
        valueGetter: (params) => get(params.data, "ExecutedContract.Name"),
        cellRenderer: (params) => {
          const executedContract = get(params.data, "ExecutedContract");
          if (!executedContract) {
            return "";
          }

          return `<a href="${executedContract.Url}" target="_blank">${executedContract.Name}</a>`;
        },
      }),
    ],
  };
}
